module.exports = __webpack_public_path__ + "static/media/banner_login.30fb4614.png";